module.exports = __webpack_public_path__ + "static/media/login-right-logo.3f32724b.png";